import { render, staticRenderFns } from "./usdt-unstake-dialog.vue?vue&type=template&id=0f71a6f4&scoped=true&"
import script from "./usdt-unstake-dialog.vue?vue&type=script&lang=ts&"
export * from "./usdt-unstake-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./usdt-unstake-dialog.vue?vue&type=style&index=0&id=0f71a6f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f71a6f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDialog,VRow})
